<template>
  <details-view-layout>
    <template v-slot:header>
      <span class="text-blue-500 border-solid border-l-2 border-gray-700 pl-2"> {{ pageTitle }}</span>
    </template>
    <template v-slot:preview>
      <embed v-if="resourceType !== 'Notebook'" type="text/html" :src="accessurl" width="1232" height="400" />
      <!--<div class="bg-gray-500 h-100 rounded">
      <div class="w-full mx-auto text-lg bg-white h-full rounded">
        <preview-map v-if='layer !== null' :layer-details='layer' />
      </div>
    </div>-->
      <!--<div class="p-6 w-full min-h-100 max-h-200">
      <layout-time-tool v-if="timetool.state.active" :startDate="prevMap.startDate" />
      <identify v-if="identify.state.active" :title="layerObj.title" :featuresObj="prevMap.selectedFeatures.value" />
      <preview-map v-if='layer !== null' :layer-details='layer' />
    </div>-->
      <!--<preview-map-container :layer-details='layer'></preview-map-container>-->
      <!--<leaflet-single-layer-map :layer-info='layer'/>-->
    </template>
    <template v-slot:content>
      <external-resource-details />
    </template>
    <template v-slot:side-bar>
      <div class="w-full p-3">
        <button
          type="button"
          class="w-full rounded inline-block px-6 py-2.5 bg-blue-500 text-white font-medium text-sm leading-tight uppercase hover:bg-blue-600 disabled:bg-gray-500"
        >
          <a :href="accessurl" target="_blank">Go to {{ resourceType }}<i class="fas fa-chevron-right pl-2" /></a>
        </button>
      </div>
    </template>
  </details-view-layout>
</template>

<script>
import DetailsViewLayout from '@/layouts/DetailsViewLayout'
import { useRoute, useRouter } from 'vue-router'
import { computed, onBeforeMount, ref } from 'vue'
import { useStore } from 'vuex'
import { ResourceSearchService } from '@/services/resource-search-service'
import { isEven } from '@/services/common/helpers'
import ExternalResourceDetails from '@/components/details-components/ExternalResourceDetails'

const resourceService = new ResourceSearchService()
export default {
  name: 'ExternalResourceLayerDetails',
  components: { ExternalResourceDetails, DetailsViewLayout },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const id = route.params.id
    const pageTitle = ref('')
    const resource = ref({})
    const accessurl = ref('')

    const resourceType = computed(() => {
      return resource?.value.resourceType === 'PythonNotebook' ? 'Notebook' : 'Application'
    })

    onBeforeMount(async () => {
      const result = await resourceService.Get(route.params.id)
      if (result.ok) {
        store.state.Details.resource = result.val
        resource.value = result.val
        pageTitle.value = store.state.Details.resource.identification.title
        // accessUrl.value = store.state.Details.resource.distribution.first.accessURL

        store.state.Details.resource.distribution.forEach((dist) => {
          accessurl.value = dist.accessURL
        })
      } else {
        console.log(result.val)
      }
    })

    const downloadDists = computed(() => {
      const l = []
      const f = ['KML', 'CSV', 'GeoJSON', 'ZIP']
      if (store.state.Details.resource !== undefined) {
        store.state.Details.resource.distribution.forEach((dist) => {
          if (f.includes(dist.format)) {
            l.push(dist)
          }
        })
      }
      return l
    })

    return { accessurl, pageTitle, id, resource, isEven, downloadDists, resourceType }
  },
}
</script>

<style scoped>

</style>
